import { render, staticRenderFns } from "./BankAccountCreationModal.vue?vue&type=template&id=5dd7f0b4&scoped=true&"
import script from "./BankAccountCreationModal.vue?vue&type=script&lang=ts&"
export * from "./BankAccountCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd7f0b4",
  null
  
)

export default component.exports